const STORAGE_KEY = 'winalist_campaign_click';
const CAMPAIGN_PATTERN = /^crm-ec-[0-9a-f]{16}$/;
const WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

/** Store a Winalist email campaign click; a newer click replaces the previous one. */
function storeCampaignClick(campaign, now) {
  if (typeof campaign !== 'string' || !CAMPAIGN_PATTERN.test(campaign)) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ campaign, clickedAt: now }));
  } catch (error) {
    // Storage can be unavailable in private browsing or blocked third-party contexts.
  }
}

/** Remember a campaign click carried by the widget URL, e.g. a direct widget link. */
export function rememberCampaignClick(search = window.location.search, now = Date.now()) {
  storeCampaignClick(new URLSearchParams(search).get('utm_campaign'), now);
}

/** Receive the campaign click of the host page, which the widget iframe URL does not carry. */
export function listenForCampaignClicks() {
  if (window.parent === window) {
    return;
  }

  window.addEventListener('message', (event) => {
    if (event.source !== window.parent || !event.data || event.data.type !== 'winalist-campaign-click') {
      return;
    }
    storeCampaignClick(event.data.campaign, Date.now());
  });

  // The host page script may have sent its click before this listener existed.
  window.parent.postMessage({ type: 'winalist-widget-ready' }, '*');
}

/** Return the remembered campaign when its click is at most seven days old. */
export function campaignForBooking(now = Date.now()) {
  try {
    const click = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (click && typeof click.campaign === 'string' && now - click.clickedAt <= WINDOW_MS) {
      return click.campaign;
    }
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // An unreadable value is treated as no campaign click.
  }

  return null;
}
